import VueRouter from 'vue-router'

import store from '../store'
import routes from './routes'

// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'nav-item active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  }
})
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isAuthenticated()) {
      next({
        path: '/me/auth/login',
        params: {
          nextUrl: to.fullPath
        }
      })
    } else {
      // TODO Check the rights e.g. hasRight(record.meta.requiresRight)
      next()
    }
  } else {
    next()
  }
})

export default router
